export interface CarouselPaginationOptions {
  clickable?: boolean;
  dynamicBullets?: boolean;
}
